import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";

const IsAnon = ({ children }) => {
  const { isLoggedIn } = useAuthContext();

  return !isLoggedIn ? children : <Navigate to={"/dashboard"} />;
};
export default IsAnon;
